{
    "Profile_SellerAgreementNotice.header": "The seller has not agreed yet",
    "Profile_SellerAgreementNotice.body": "The seller has not agreed to the application. Don't charge the card or issue the policy until they do.",
    "Profile_SellerAgreementNotice.sent": "The Agree email went to the seller on {sentOn}.",
    "Profile_SellerAgreementNotice.record": "If the seller agreed another way, by phone for instance, an administrator can record it under Secure My Offer, Seller agreement."
}
